import { render, staticRenderFns } from "./Pop_up.vue?vue&type=template&id=3c8e658e&"
import script from "./Pop_up.vue?vue&type=script&lang=js&"
export * from "./Pop_up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports